import combineReducers from 'react-combine-reducers';

import InspectionReducer from './components/Inspection/InspectionReducer';
import ListingReducer from './pages/listing/ListingReducer';
import UploadImageReducer from './common/UseReducerHook/uploadImageReducer';
import LayoutReducer from './common/UseReducerHook/layoutReducer';
import AppointmentsReducer from './common/UseReducerHook/appointmentsReducer';
import InvoiceReducer from './components/Invoicing/invoicingReducer';

const RootReducers = () => {
  const [RootReducer, initialState] = combineReducers({
    inspection: [InspectionReducer, {}],
    listing: [ListingReducer, {}],
    images: [UploadImageReducer, {}],
    layout: [LayoutReducer, {}],
    appointments: [AppointmentsReducer],
    invoiceContext: [InvoiceReducer],
  });
  return [RootReducer, initialState];
};

export default RootReducers;
